<template>
  <b-card
    no-body
    :class="[{'open': visible}, 'queue-specialists', margin]"
    @mouseenter="collapseOpen"
    @mouseleave="collapseClose"
  >
    <b-card-header
      :class="[{'collapsed': !visible}]"
      :aria-expanded="visible ? 'true' : 'false'"
      :aria-controls="collapseItemID"
      role="tab"
      data-toggle="collapse"
      @click="updateVisible(!visible)"
    >
      <span name="header">
        <b-row class="avatar-overlay">
          <b-overlay
            :show="isLoading && getWidgetSettings.timeslot_display_mode === 1"
            class="ml-1 mr-1"
            spinner-small
            spinner-type="grow"
            size="sm"
            rounded
            opacity="0.5"
          >
            <b-avatar
              size="60"
              variant="light"
              :style="{color: getWidgetSettings.main_color}"
              :src="workspace.avatar"
              :text="setAcronym(workspace.description)"
            />
          </b-overlay>
          <b-col align="start" :class="getWidgetSettings.show_rating ? 'column queue-specialist-name' : 'queue-specialist-name'">
            <span class="lead collapse-title queue-bloc-title">{{ shortenStringIfTooLong(workspace.name, 39, 13) }}</span><br>
            <small class="text-secondary">{{ shortenStringIfTooLong(workspace.description, 53, 14) }}</small><br>
            <b-form-rating
              v-if="getWidgetSettings.show_rating"
              :class="getWidgetSettings.show_rating ? 'my-form-control':''"
              :dir="getLanguage === 'ar' ? 'rtl' : 'ltr'"
              no-border
              inline
              :value="workspace.middle_star"
              readonly
              variant="warning"
              size="sm"
              show-value
              precision="1"
            />
          </b-col>
        </b-row>
      </span>
    </b-card-header>

    <b-collapse
      :id="collapseItemID"
      v-model="visible"
      :accordion="accordion"
      role="tabpanel"
    >
      <InlineCalendar
        v-if="getWidgetSettings.timeslot_display_mode === 2"
        ref="inlineCalendar"
        :workspace="workspace"
        :service="service"
        @select-date="selectDate"
        @openModal="showForm"
      />
      <GridCalendar
        v-else
        :visible="visible"
        :exist-timeslots="existTimeslot"
        @openForm="showForm"
      />
    </b-collapse>
  </b-card>
</template>

<script>
import {
  BCard, BCardHeader, BCollapse, BCol, BRow, BAvatar, BFormRating, BOverlay,
} from 'bootstrap-vue'
import { v4 as uuidv4 } from 'uuid'
import Ripple from 'vue-ripple-directive'
// import axios from '@/libs/axios'
import i18n from '@/libs/i18n'
import { mapGetters, mapActions, mapMutations } from 'vuex'
import { shortenStringIfTooLong, setAcronym, getFormattedDateForBackend } from '@/libs/utils'
import InlineCalendar from '@/components/booking/calendars/inline/InlineCalendar.vue'
import GridCalendar from '@/components/booking/calendars/grid/GridCalendar.vue'

export default {
  directives: {
    Ripple,
  },
  components: {
    BCard,
    BCardHeader,
    BCollapse,
    BCol,
    BRow,
    BAvatar,
    BFormRating,
    BOverlay,
    InlineCalendar,
    GridCalendar,
  },
  props: {
    isVisible: {
      type: Boolean,
      default: false,
    },
    workspace: {
      type: Object,
      // eslint-disable-next-line vue/require-valid-default-prop
      default: {},
      required: true,
    },
    service: {
      type: String,
      required: true,
    },
    margin: {
      type: String,
      default: ''
    },
  },
  data() {
    return {
      selectedDate: getFormattedDateForBackend(new Date()),
      calendarType: 1,
      isLoading: false,
      visible: false,
      collapseItemID: '',
      openOnHover: this.$parent.hover,
      existTimeslot: true,
      i18n,
      shortenStringIfTooLong,
      setAcronym,
    }
  },
  computed: {
    ...mapGetters(['getWidgetSettings', 'getLanguage']),
    accordion() {
      return this.$parent.accordion ? `accordion-${this.$parent.collapseID}` : null
    },
  },
  created() {
    this.collapseItemID = uuidv4()
    this.visible = this.isVisible
  },
  methods: {
    ...mapActions(['fetchAllDaysTimeslots', 'fetchDayTimeslotsAndCountdown']),
    ...mapMutations(['UPDATE_ALL_TIMESLOTS']),
    setLoading(val) {
      if (this.getWidgetSettings.timeslot_display_mode === 2) {
        if (val) {
          this.isLoading = val
          this.$refs.inlineCalendar.setLoading(val)
          return
        }
        setTimeout(() => {
          this.isLoading = val
          this.$refs.inlineCalendar.setLoading(val)
        }, 500)
      } else {
        this.isLoading = val
      }
    },
    selectDate(val) {
      this.setLoading(true)
      this.selectedDate = getFormattedDateForBackend(val)
      this.fetchTimeslotsForCalendarTypeTwo()
    },
    showForm(val) {
      this.$emit('openForm', { timeslot: val.timeslot, day: val.day, workspace: this.workspace })
    },
    async updateVisible(val = true) {
      if (val === true) {
        this.setLoading(true)
        if (this.workspace.category === 1 && this.getWidgetSettings.timeslot_display_mode === 1) {
          await this.fetchTimeslotsForCalendarTypeOne()
        } else if (this.workspace.category === 1 && this.getWidgetSettings.timeslot_display_mode === 2) {
          await this.fetchTimeslotsForCalendarTypeTwo()
        }
      } else {
        this.UPDATE_ALL_TIMESLOTS([])
      }
      this.visible = val
      // this.$emit('visible', val)
    },
    countTimeslots(res) {
      let count = 0
      // eslint-disable-next-line no-plusplus
      for (let i = 0; i < res.timeslots.length; ++i) {
        if (res.timeslots[i].length > 0) {
          count += 1
        }
      }
      if (count === 0) {
        this.existTimeslot = false
      }
    },
    collapseOpen() {
      if (this.openOnHover) this.updateVisible(true)
    },
    collapseClose() {
      if (this.openOnHover) this.updateVisible(false)
    },
    async fetchTimeslotsForCalendarTypeOne() {
      await this.fetchAllDaysTimeslots({ workspace: this.workspace.id, service: this.service })
        .then(response => {
          this.countTimeslots(response)
          this.setLoading(false)
        })
        .catch(error => {
          this.setLoading(false)
          console.error(error)
        })
    },
    fetchTimeslotsForCalendarTypeTwo() {
      const data = {
        workspace: this.workspace.id,
        services: [this.service],
        day: getFormattedDateForBackend(this.selectedDate),
        start_time: null,
        record: null,
      }
      this.fetchDayTimeslotsAndCountdown(data).then(response => {
        this.timeslots = response.data.timeslots
        this.setLoading(false)
      }).catch(error => {
        this.setLoading(false)
        console.error(error)
      })
    },
  },
}
</script>
<style>

</style>
